"use client"

import { LocatorMapType } from 'map-feature/type';
import { createContext, ReactNode, useContext, useState } from 'react';

interface MapTypeContextValue {
  mapType: LocatorMapType;
  setMapType: (type: LocatorMapType) => void;
}

const MapTypeContext = createContext<MapTypeContextValue | undefined>(undefined);

const MapTypeProvider = ({ children, initialMapType }: { children: ReactNode, initialMapType: LocatorMapType }) => {
  const [mapType, setMapType] = useState<LocatorMapType>(initialMapType);

  return (
    <MapTypeContext.Provider value={{ mapType, setMapType }}>
      {children}
    </MapTypeContext.Provider>
  );
};

// Custom hook to use the map type context
const useMapType = () => {
  const context = useContext(MapTypeContext);
  if (!context) {
    throw new Error('useMapType must be used within a MapTypeProvider');
  }
  return context;
};

export { LocatorMapType, MapTypeProvider, useMapType };
